import React, {
  FC, useCallback, useEffect, useState,
} from 'react';

import { AffectedQuestions } from '../../commons/AffectedQuestions';
import { QBackButton } from '../../commons/QBackButton';
import { QConfirmButton } from '../../commons/QConfirmButton';
import { QHeader } from '../../commons/QHeader';
import { Q8Form, Q8Response } from './form';
import { Row } from 'components/base/Row';

import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { Address } from 'modules/budget/models/Address';
import { ILocation } from 'modules/budget/models/Location/types';

export const Q8: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q8;
  const { RespondQuestion } = useBudget();

  const [dismissService, setDismissService] = useState<boolean>(false);
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<ILocation | null>(null);
  const [enabledReply, setEnabledReply] = useState<boolean>();
  const [autorespond, setautorespond] = useState<boolean>(false);

  useEffect(
    () => {
      const isAddressFullfilled = selectedAddress?.isFullFilled() || false;
      setEnabledReply(dismissService === true
        || (dismissService === false && isAddressFullfilled && Boolean(selectedLocation)));
    },
    [dismissService, selectedAddress, selectedLocation],
  );

  const response = useCallback(
    ({ gotoSummary }) => {
      if (!dismissService) {
        if (selectedAddress && selectedLocation) {
          RespondQuestion({
            gotoSummary,
            question,
            response: {
              address: selectedAddress,
              location: selectedLocation,
            },
          });
        }
      } else {
        RespondQuestion({
          gotoSummary,
          question,
        });
      }
    },
    [RespondQuestion, dismissService, question, selectedAddress, selectedLocation],
  );

  const onChange = useCallback(
    (responseData: Q8Response) => {
      setDismissService(Boolean(responseData.dismissService));
      setSelectedAddress(responseData.address);
      setSelectedLocation(responseData.location);
      setautorespond(responseData.autorespond);
    },
    [],
  );

  useEffect(
    () => {
      if (autorespond && enabledReply) {
        setautorespond(false);
        response({ gotoSummary: false });
      }
    },
    [autorespond, enabledReply, response],
  );

  return (
    <React.Fragment>
      <QHeader question={question} />
      <Q8Form
        question={BudgetQuestionCodes.Q8}
        onChange={onChange}
      />
      <Row justifyContent="space-between">
        <QBackButton question={question} />
        <Row
          className="f-question-actions"
          justifyContent="flex-end"
        >
          <AffectedQuestions
            question={question}
            response={{
              address: selectedAddress,
              location: selectedLocation,
            }}
          />
          <QConfirmButton
            disabled={!enabledReply}
            question={question}
            onClick={(payload) => response({ gotoSummary: payload?.gotoSummary })}
          />
        </Row>
      </Row>
    </React.Fragment>
  );
};
